import axios from "axios";
import queryString from "query-string";

import { baseURL, timeout, ctype } from "../const";
import { storage } from "../util";

interface AnyType {
  [key: string]: any;
}

axios.defaults.baseURL = baseURL;
axios.defaults.timeout = timeout;

axios.defaults.headers.post["Content-Type"] = ctype;

interface reqInterface {
  url: string;
  params?: { [key: string]: any };
  method?: string;
  isQuery?: boolean;
  headers?: { [key: string]: any };
  ignoremsg?: boolean;
  loginRequire?: boolean;
}

type reqProps = string | reqInterface;

export const request: (a: reqInterface) => Promise<any> = (p: reqProps) => {
  let authToken = storage.get("atoken") || ""; // 可能是{}
  const userId = storage.get("auserid") || "";

  let url = "";
  let params: AnyType | undefined = undefined;

  let method: string | undefined = "get";
  let isQuery: boolean | undefined = false;
  let headers: AnyType | undefined = {};
  if (typeof p !== "string") {
    url = p.url;
    params = { ...p.params };
    method = p.method || "get";
    isQuery = p.isQuery || false;
    headers = {
      ...(p.headers || {}),
      authToken,
      userId,
    };
  } else {
    url = p;
    method = "get";
    isQuery = false;
    headers = {
      authToken,
      userId,
    };
    params = {};
  }
  console.log("========request=============", url, method, params);
  params = { ...params };
  if (Object.keys(params || ({} as AnyType)).length) {
    Object.keys(params || {}).forEach((k) => {
      if (
        (params || {})[k] === undefined ||
        (params || {})[k] === "" ||
        (params || {})[k] === null
      )
        delete (params || {})[k];
    });
  }
  const _method = method!.toLowerCase();
  let sparam; // = _method === 'get' ? { params } : params
  if (_method === "get") {
    if (isQuery) {
      url += "?" + queryString.stringify(params!);
      sparam = null;
    } else {
      sparam = { params };
    }
  } else {
    if (isQuery) {
      url += "?" + queryString.stringify(params!);
      sparam = null;
    } else {
      sparam = JSON.stringify(params);
    }
  }

  const rp: { [key: string]: any } = {
    url,
    method,
    data: sparam,
  };
  if (Object.keys(headers)) {
    rp.headers = headers;
  }

  return axios(rp)
    .then((response) => {
      const { msg, source, status } = response.data as any;
      if (status == 200) {
        return source;
      } else if (status == 403) {
        window.localStorage.clear();
        setTimeout(() => {
          window.location.href = "/#/";
        }, 300);
      }
      return Promise.reject(response.data);
    })
    .catch((error) => {
      if (error.status == "403") {
        window.localStorage.clear();
        setTimeout(() => {
          window.location.href = "/#/";
        }, 300);
      }
      // return Promise.reject(error);
    });
};
